import { STEPPER_GLOBAL_OPTIONS, StepperOrientation } from '@angular/cdk/stepper';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormControl, AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Observable, forkJoin, map, startWith } from 'rxjs';
import { Country } from 'src/app/core/models/country.model';
import { kraPintype } from 'src/app/core/models/kRAPintype.model';
import { QuotationInfo } from 'src/app/core/models/quotations-info.model';
import { Quote } from 'src/app/core/models/quote.model';
import { Relationship } from 'src/app/core/models/relationship.model';
import { TravelPurpose } from 'src/app/core/models/travel-purpose.model';
import { Traveller } from 'src/app/core/models/traveller.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import {BreakpointObserver} from '@angular/cdk/layout';
import { ContentLoaderService } from 'src/app/core/services/content-loader.service';
import { PolicyService } from 'src/app/core/services/policy.service';
import { TranslateService } from '@ngx-translate/core';
export function atLeastOneProposerValidator(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAtLeastOneSelected = (formArray as FormArray).controls
      .some(control => control.get('isProposerATraveller')?.value);

    return isAtLeastOneSelected ? null : { atLeastOneRequired: true };
  };
}
export function minAgeValidation(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAtLeastOneAboveOrEqual3 = (formArray as FormArray).controls
      .some(control => {
        const age = control.get('age')?.value;
        return age !== null && age >= 3;
      });

    return isAtLeastOneAboveOrEqual3 ? null : { minAgeRequired: true };
  };
}

export function oldAgeRestrictionValidation(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAnyOldAgePersion = (formArray as FormArray).controls
      .some(control => {
        const age = control.get('age')?.value;
        return age !== null && age > 80;
      });

    return isAnyOldAgePersion ? { oldAgeRestriction: true } : null;
  };
}

export function allSelectedValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const formArray = control as FormArray;
    return formArray.controls.every(ctrl => ctrl.value === true) ? null : { notAllSelected: true };
  };
}
@Component({
  selector: 'app-proposal-form-v1',
  templateUrl: './proposal-form-v1.component.html',
  styleUrls: ['./proposal-form-v1.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class ProposalFormV1Component {
    messages = [
    "We're crafting your policy. Thanks for waiting!",
    "Your policy is on its way. Hang in there!",
    "Just a moment longer for your custom policy.",
    "We're working on your policy. Almost done!",
    "Thanks for your patience while we generate your policy.",
    "Sit tight! Your policy is being tailored.",
    "Your policy is in progress. Appreciate your patience!",
    "Just a few more seconds for your personalized policy.",
    "Your policy is getting ready. Thanks for waiting!",
    "We're on it! Your policy will be ready soon."
  ];
  isLinear = true;
  submitted: boolean = false;
  filteredDestinations: Observable<Country[]> | undefined;
  selectedDestinations: Country[] = [];
  @ViewChild('destinationInput') destinationInput!: ElementRef<HTMLInputElement>;
  minTripEndDate: any;
  getTravelPurposeList: TravelPurpose[] = [];
  getCountriesList: Country[] = [];
  declarationList:any[]=[];
  consentList:any[]=[];
  allDeclarationsControl = new FormControl(false);
  allConsentsControl = new FormControl(false);
  dateOfBirthMaxDate = new Date();
  quotationId: string = '';
  quotesId: string = '';
  selectedProduct!: Quote;
  quotesInfo!: QuotationInfo;
  travellerList: Traveller[] = [];
  selectedFile: File | null = null;
  selectedTemplateFile: File | null = null;
  countryCodes: any[] = [];
  relationshipList: Relationship[] = [];
  kRAPintypeList:kraPintype[]=[];
  selectedDeclarationsInEditMode:any[]=[];
  selectedConsentListInEditMode:any[]=[];
  numberOfApprovedUsers:number=0;
  edit:boolean=false;
   currentLanguage: string = '';
  travelDetailsForm = this.fb.group({
    productName: [{ value: '', disabled: true }, Validators.required],
    premiumAmount: [{ value: '', disabled: true }, Validators.required],
    destination: [{ value: '', disabled: true }, Validators.required],
    tripStartDate: [{ value: '', disabled: true }, Validators.required],
    tripEndDate: [{ value: '', disabled: true }, Validators.required],
    travelingDays: [{ value: '', disabled: true }, Validators.required],
    numberOfTravelers: [{ value: '', disabled: true }, Validators.required]
  });

  travelerInformationForm = this.fb.group({
    travelersDetails: this.fb.array([], [atLeastOneProposerValidator(), minAgeValidation(),oldAgeRestrictionValidation()]),
  });

  additionalInformationForm = this.fb.group({
    kraPinType: ['', Validators.required],
    kraPinNumber: [{ value: '', disabled: true }, [Validators.required, this.kraPinNumberValidator]],
    insuredOccupation: ['', Validators.required],
    address: this.fb.group({
      houseNumber: ['', Validators.required],
      roadName: ['', Validators.required],
      pincode: ['', Validators.required]
    })
  });

  beneficiaryDetailsForm = this.fb.group({
    beneficiaryName: ['', Validators.required],
    beneficiaryTelephoneNo: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]]
  });

  declarationForm = this.fb.group({
    declarationInfo: this.fb.array([], allSelectedValidator()),
    consentInfo: this.fb.array([], allSelectedValidator())
  });

  uploadTemplateForm = this.fb.group({
    template: [''],
  });
  stepperOrientation: Observable<StepperOrientation>;
  isBulkUpload:boolean=false;
  userProposalBulkList:any[]=[];
  currentMessage!: string;
  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    public breakpointObserver: BreakpointObserver,
    private contentLoaderService: ContentLoaderService,
    private policyService: PolicyService,
     private translate: TranslateService
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
      this.quotesId = params['quotesId'];
    });

    this.filteredDestinations = this.travelDetailsForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
    if(this.router.url.includes('edit')){
      this.edit=true;
    }
    else{
      this.edit=false;
    }
     this.currentLanguage = this.translate.currentLang;
     this.translate.onLangChange.subscribe((event: any) => {
      this.currentLanguage = event.lang;
     })
  }

  ngOnInit() {
    this.GetMasterData();
  }

  get getDeclarationInfo(): FormArray {
    return this.declarationForm.get('declarationInfo') as FormArray;
  }

  get  getConsentInfo(): FormArray {
      return this.declarationForm.get('consentInfo') as FormArray;
  }

  onFileSelected(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.onUpload(index);
    } else {
      this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.patchValue('');
    }
  }

  onUpload(index: number) {
    if (!this.selectedFile) {
      console.error('No file selected');
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile, this.selectedFile.name);
    this.loader.show();
    this.restService.postData(formData, 'api/FileUpload/InsertPassport').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.patchValue(data.rObj.AttachmentID);
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  GetMasterData() {
    let getQuotesUserInfoParams = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }
    const getMasterDataApiCall$ = this.restService.postData({
    "id": this.currentLanguage == 'en' ? '1' : '2', // Assuming 1 is for English and 2 for other languages
}, 'api/Quotation/GetMasterData');
    const getQuotesUserInfoApiCall$ = this.restService.postData(getQuotesUserInfoParams, 'api/Quotation/UserInfo');
    this.loader.show();
    forkJoin([getMasterDataApiCall$, getQuotesUserInfoApiCall$]).subscribe(
      {
        next: ([masterData, userInfoData]) => {
          try {
            if (masterData.rcode == 200 && userInfoData.rcode == 200) {
              this.getTravelPurposeList = masterData.rObj.GetTravelPurpose || [];
              this.getCountriesList = masterData.rObj.GetCountries || [];
              this.relationshipList = masterData.rObj.Relationship || [];
              this.countryCodes = masterData.rObj.CountryCode || [];
              this.kRAPintypeList = masterData.rObj.kRAPintype || [];
              this.declarationList = masterData.rObj.declaration || [];
              this.consentList = masterData.rObj.consent || [];
              
              this.setupValueChanges();
              // this.GetQuotesUserInfo();

              this.quotesInfo = userInfoData.rObj.Quotations;
              this.isBulkUpload=this.quotesInfo.IsBulk;
              this.selectedProduct = userInfoData.rObj.Quotes;
              this.travellerList = this.isBulkUpload?[]:userInfoData.rObj.Traveller || [];
              let selectedDestinationsList = userInfoData.rObj.DestinationCountry || [];
              let selectedDestinationsIds = selectedDestinationsList.map((sdl: any) => sdl.DestinationCountryID);
              this.selectedDestinations = this.getCountriesList.filter(country => selectedDestinationsIds.includes(country.TocountryID));
              this.selectedDeclarationsInEditMode=userInfoData.rObj.declarations;
              this.selectedConsentListInEditMode=userInfoData.rObj.declarations;
              this.initializeDeclarationInfoControls();
              this.initializeConsentInfoControls();
              this.SetValuesToProposalForm();
              if(!this.isBulkUpload){
                this.numberOfTravelers();
              }else{
                this.GetUserProposalBulk();
              }
            } else if(masterData.rcode != 200){
              this.errorHandler.handleRcodeError(masterData);
            }else if(userInfoData.rcode != 200){
              this.errorHandler.handleRcodeError(userInfoData);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  selectAllDeclarations(selectAll: boolean): void {
    const declarationInfo = this.declarationForm.get('declarationInfo') as FormArray;
    declarationInfo.controls.forEach(control => control.setValue(selectAll));
    this.updateAllDeclarationsSelected();
  }
  
  selectAllConsents(selectAll: boolean): void {
    const consentInfo = this.declarationForm.get('consentInfo') as FormArray;
    consentInfo.controls.forEach(control => control.setValue(selectAll));
    this.updateAllConsentsSelected();
  }
 
  updateAllDeclarationsSelected(): void {
    const allSelected = this.getDeclarationInfo.controls.every(control => control.value);
    if (this.allDeclarationsControl.value !== allSelected) {
      this.allDeclarationsControl.setValue(allSelected, { emitEvent: false });
    }
  }

  updateAllConsentsSelected(): void {
    const allSelected = this.getConsentInfo.controls.every(control => control.value);
    if (this.allConsentsControl.value !== allSelected) {
      this.allConsentsControl.setValue(allSelected, { emitEvent: false });
    }
  }
  
  setupValueChanges(): void {
    this.additionalInformationForm.get('kraPinType')?.valueChanges.subscribe(value => {
      const kraPinNumberControl = this.additionalInformationForm.get('kraPinNumber');
      if (value) {
        kraPinNumberControl?.enable();
      } else {
        kraPinNumberControl?.disable();
      }
    });

    this.additionalInformationForm.get('kraPinNumber')?.valueChanges.subscribe(value => {
      if (value) {
        this.additionalInformationForm.get('kraPinNumber')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  kraPinNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if(!value){
      return null;
    }
    if (value && value.length === 11 && /^[A-Z]\d{9}[A-Z]$/.test(value)) {
      return null;
    }
    return { invalidKraPinNumber: true };
  }

  initializeDeclarationInfoControls(): void {
    const declarationInfo = this.declarationForm.get('declarationInfo') as FormArray;
    this.declarationList.forEach((declaration) => {
      const exists = this.selectedDeclarationsInEditMode.some(item => item.declarationid == declaration.masterDataID);
      declarationInfo.push(new FormControl(exists))
    }
    );
    this.updateAllDeclarationsSelected();
  }

  initializeConsentInfoControls(): void {
    const consentInfo = this.declarationForm.get('consentInfo') as FormArray;
    this.consentList.forEach((consent) =>{
      const exists = this.selectedConsentListInEditMode.some(item => item.declarationid == consent.masterDataID);
      consentInfo.push(new FormControl(exists))
    });
    this.updateAllConsentsSelected();
  }

  GetQuotesUserInfo() {
    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/UserInfo').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.quotesInfo = data.rObj.Quotations;
              this.selectedProduct = data.rObj.Quotes;
              this.travellerList = data.rObj.Traveller || [];
              let selectedDestinationsList = data.rObj.DestinationCountry || [];
              let selectedDestinationsIds = selectedDestinationsList.map((sdl: any) => sdl.DestinationCountryID);
              this.selectedDestinations = this.getCountriesList.filter(country => selectedDestinationsIds.includes(country.TocountryID));
              this.SetValuesToProposalForm();
              this.numberOfTravelers();
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  SetValuesToProposalForm() {
    this.travelDetailsForm.patchValue({
      productName: this.selectedProduct.ProductName,
      premiumAmount: this.selectedProduct.sTotalAmount,
      tripStartDate: this.quotesInfo.FromDate,
      tripEndDate: this.quotesInfo.ToDate,
      travelingDays: this.quotesInfo.NoofDays.toString(),
      numberOfTravelers: this.quotesInfo.NoofTravellers.toString()
    });

    if(!this.isBulkUpload){
      this.additionalInformationForm.patchValue({
        kraPinType: this.quotesInfo.KRAPinTypeID=='00000000-0000-0000-0000-000000000000'?null:this.quotesInfo.KRAPinTypeID,
        kraPinNumber: this.quotesInfo.KRAPinNumber,
        insuredOccupation: this.quotesInfo.Occupation,
        address: {
          houseNumber: this.quotesInfo.AddressLine1,
          roadName: this.quotesInfo.AddressLine2,
          pincode: this.quotesInfo.AddressLine3
        }
      });
    
      this.beneficiaryDetailsForm.patchValue({
        beneficiaryName: this.quotesInfo.BeneficiaryName,
        beneficiaryTelephoneNo: this.quotesInfo.BeneficiaryPhoneNumber
      });
    }
 
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  newTravelersDetaile(traveller: Traveller): FormGroup {
    return this.fb.group({
      isProposerATraveller: [{ value: traveller.IsPolicyHolder, disabled: true }, Validators.required],
      // title: [''],
      firstName: [traveller.FirstName, Validators.required],
      lastName: [traveller.LastName, Validators.required],
      nameAsPerThePassport: [traveller.Fullname, Validators.required],
      dateOfBirth: [ { value: traveller.DOB, disabled: true }, Validators.required],
      age: [{ value: traveller.Age, disabled: true }, Validators.required],
      mobileCode: [this.countryCodes.length == 1 ? this.countryCodes[0].masterDataID : traveller.PhoneNumberCountryCode, Validators.required],
      mobileNumber: [traveller.sPhoneNumber, [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
      emailId: [traveller.EmailId, [Validators.required, Validators.email]],
      passportNumber: [traveller.PolicyHolderPassPortNumber, Validators.required],
      relationshipWithTheProposer: [{
        value: traveller.IsPolicyHolder ? 'eaf41d97-4dd2-4406-b351-5424e55507b2' :
          traveller.RelationshipTypeID == '00000000-0000-0000-0000-000000000000' ? null : traveller.RelationshipTypeID
        , disabled: traveller.IsPolicyHolder
      }, Validators.required],
      passportFile: [null],
      passportFileAttachmentID: [traveller.PassportAttachmentID || null]
    })

  }

  onProposerChange(selectedGroup: any, selected: boolean) {
    if (selected) {
      this.disableOtherProposerControls(selectedGroup);
    } else {
      this.enableAllProposerControls();
    }
    this.getTravelersDetails.updateValueAndValidity();
  }

  disableOtherProposerControls(selectedGroup: FormGroup) {
    this.getTravelersDetails.controls.forEach(group => {
      if (group !== selectedGroup) {
        group.get('isProposerATraveller')?.disable();
      }
    });
  }

  disableOtherProposerControlsOnPatchValue() {
    this.getTravelersDetails.controls.forEach(group => {
      if (!group.get('isProposerATraveller')?.value) {
        group.get('isProposerATraveller')?.disable();
      }
    });
  }

  enableAllProposerControls() {
    this.getTravelersDetails.controls.forEach(group => {
      group.get('isProposerATraveller')?.enable();
    });
  }

  get getTravelersDetails(): FormArray {
    return this.travelerInformationForm.get("travelersDetails") as FormArray;
  }

  numberOfTravelers(): void {
    this.getTravelersDetails.clear();
    for (const traveller of this.travellerList) {
      this.getTravelersDetails.push(this.newTravelersDetaile(traveller));
    }
    this.disableOtherProposerControlsOnPatchValue();
  }

  removeTravelersDetaile(i: number) {
    this.getTravelersDetails.removeAt(i);
  }

  remove(destination: Country): void {
    const index = this.selectedDestinations.indexOf(destination);
    if (index >= 0) {
      this.selectedDestinations.splice(index, 1);
      this.onFocus();
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedCountry = this.getCountriesList.find(country => country.TocountryID === event.option.value);
    if (selectedCountry) {
      this.selectedDestinations.push(selectedCountry);
      this.destinationInput.nativeElement.value = '';
      this.travelDetailsForm.get('destination')?.patchValue('');
      this.onFocus();
    }
  }

  private _filter(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.getCountriesList.filter(country =>
      country.ToCountryName.toLowerCase().includes(filterValue) &&
      !this.selectedDestinations.some(selected => selected.TocountryID === country.TocountryID)
    );
  }

  onFocus() {
    this.filteredDestinations = this.travelDetailsForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
  }

  calculateAge(dob: Date): number {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  dateOfBirthChange(event: MatDatepickerInputEvent<Date>, index: number) {
    let dob = this.getTravelersDetails.at(index).get('dateOfBirth')?.value;
    let getAge = this.calculateAge(dob);
    this.getTravelersDetails.at(index).get('age')?.patchValue(getAge);
  }

  submit() {
    this.submitted = true;
    if(this.isBulkUpload){

      if (
        this.travelDetailsForm.invalid ||
        this.uploadTemplateForm.invalid ||
        this.declarationForm.invalid 
        ) {
        return;
      }
      let _dialogRef = this.dialog.open(NotificationComponent, {
        disableClose: true,
        panelClass: 'dialog-class',
        data: {
          block: 'notificationYesOrNO',
          message: 'Are you sure you want to submit the Proposal?',
        }
      });
  
      _dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.DeclarationUpdate();
        }
      });

    }else{
      if (
        this.travelDetailsForm.invalid ||
        this.travelerInformationForm.invalid ||
        this.additionalInformationForm.invalid ||
        this.beneficiaryDetailsForm.invalid ||
        this.declarationForm.invalid 
        ) {
        return;
      }
  
      let _dialogRef = this.dialog.open(NotificationComponent, {
        disableClose: true,
        panelClass: 'dialog-class',
        data: {
          block: 'notificationYesOrNO',
          message: 'Are you sure you want to submit the Proposal?',
        }
      });
  
      _dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.UserProposal();
        }
      });

    }
  


  }

  UserProposal() {
    const selectedDeclarations = this.declarationForm.get('declarationInfo')?.value
    .map((checked, index) => checked ? { DeclarationId: this.declarationList[index].masterDataID } : null)
    .filter(value => value !== null);

    const selectedConsents = this.declarationForm.get('consentInfo')?.value
    .map((checked, index) => checked ? { ConsentId: this.consentList[index].masterDataID } : null)
    .filter(value => value !== null);

    let travelersDetails = this.travelerInformationForm.get('travelersDetails')?.getRawValue() || [];
    const addressGroup = this.additionalInformationForm.get('address') as FormGroup;
    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.selectedProduct.QuotesID,
      ProductName: this.travelDetailsForm.get("productName")?.value,
      ProductID: this.selectedProduct.ProductID,
      ProductSourceID: this.selectedProduct.ProductSourceID,
      TotalAmount: this.selectedProduct.TotalAmount,
      ToCountriesId: this.selectedDestinations.map(({ ToCountrySourceId, TocountryID, ToCountryName, ToCountryCode }) => ({
        CountrySourceId: ToCountrySourceId,
        CountryId: TocountryID,
        CountryName: ToCountryName,
        CountryCode: ToCountryCode
      })),
      AddressLine1: addressGroup.get('houseNumber')?.value,
      AddressLine2: addressGroup.get('roadName')?.value,
      AddressLine3: addressGroup.get('pincode')?.value,
      AddressLine4: "",
      AddressLine5: "",
      FromDate: moment(this.travelDetailsForm.get("tripStartDate")?.value).format('YYYY-MM-DD'),
      ToDate: moment(this.travelDetailsForm.get("tripEndDate")?.value).format('YYYY-MM-DD'),
      NoofDays: parseInt(this.travelDetailsForm.get("travelingDays")?.value || '', 10),
      NoofTravellers: parseInt(this.travelDetailsForm.get("numberOfTravelers")?.value || '', 10),
      TravellersInformation: travelersDetails.map((td: any) => {
        let selectedRelationship: Relationship = this.relationshipList.find(relationship => relationship.masterDataID == td.relationshipWithTheProposer) as Relationship;
        return {
          FirstName: td.firstName,
          LastName: td.lastName,
          FullName: td.nameAsPerThePassport,
          DOB: td.dateOfBirth ? moment(td.dateOfBirth).format('YYYY-MM-DD') : null,
          Age: td.age ? parseInt(td.age, 10) : null,
          // CountryCode: td.mobileCode,
          CountryCode: 254,
          MobileNumber: parseInt(td.mobileNumber, 10),
          Email: td.emailId,
          PassportNumber: td.passportNumber,
          RelationshipID: td.relationshipWithTheProposer,
          Relationship: selectedRelationship?.mdTitle,
          PassportID: td.passportFileAttachmentID || null,
          IsPolicyHolder: td.isProposerATraveller,
        }
      }),
      KRAPinTypeID:this.additionalInformationForm.get("kraPinType")?.value,
      KRAPinNumber:this.additionalInformationForm.get("kraPinNumber")?.value,
      Occupation:this.additionalInformationForm.get("insuredOccupation")?.value,
      Postaladdress:null,
      DeclarationInfo:selectedDeclarations,
      ConsentInfo:selectedConsents,
      BeneficiaryName:this.beneficiaryDetailsForm.get("beneficiaryName")?.value,
      BeneficiaryPhoneNumber:this.beneficiaryDetailsForm.get("beneficiaryTelephoneNo")?.value
    }
    
    this.loader.show();
    let url:any
    if(!this.edit){
    url = 'api/Quotation/UserProposal'
    }
    else {
     url = 'api/Quotation/UserProposalModify'
    }
    this.restService.postData(params, url).subscribe(
      {
        next: (data: any) => {
          try {

            if (data.rcode == 200) {
               if(this.edit){
                this.quotationStatusUpdate()
              }
              else{
                this.loader.hide();
              this.router.navigate(['policy/underwriting', this.quotationId, this.quotesId]);
              }
            }
            else if (data.rcode == 504) {
              this.loader.hide();
              this.errorHandler.hasOverlappingPassportDatesError(data);
            } 
             else {
              this.loader.hide();
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.loader.hide();
            this.errorHandler.internalError();
          } finally {
            //this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      });
  }

  goBack() {
    this.router.navigate(['quotation/quotation-premium', this.quotationId]);
  }

  DownloadPassportCopy(index: number) {
    let attachmentID = this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.value
    let params = {
      AttachmentID: attachmentID
    }
    this.loader.show();
    this.restService.postData(params, 'api/Download/DownloadUserProfile').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              if (data.rObj.URL) {
                window.open(data.rObj.URL, '_target');
              }
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  DownloadPolicyExcelTemplate(){
    let params={
      quotationId:this.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/DownloadPolicyExcelTemplate').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 1) {
              if (data.rObj.URL) {
                window.open(data.rObj.URL, '_target');
              }
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  GetUserProposalBulk() {
    let params={
      quotationID:this.quotationId,
      quotesID:this.quotesId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/GetUserProposalBulk').subscribe(
      {
        next: (data: any) => {
          try {

            if (data.rcode == 200) {
              this.userProposalBulkList=data.rObj.GetUserProposalBulk || [];
              this.numberOfApprovedUsers=data.rObj.ApprovedUsers;
              this.userProposalBulkList = this.userProposalBulkList.map(up => {
                up.eRRORMESSAGE = up.eRRORMESSAGE ? JSON.parse(up.eRRORMESSAGE) : [];
                return up;
              });
              
            }
            else if (data.rcode == 504) {
              this.errorHandler.hasOverlappingPassportDatesError(data);
            } 
             else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      });
  }
  
  GetQuotesBulk(){
    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.selectedProduct.QuotesID,
      ProductName: this.travelDetailsForm.get("productName")?.value,
      ProductID: this.selectedProduct.ProductID,
      ProductSourceID: this.selectedProduct.ProductSourceID,
      TotalAmount: this.selectedProduct.TotalAmount,
      ToCountriesId: this.selectedDestinations.map(({ ToCountrySourceId, TocountryID, ToCountryName, ToCountryCode }) => ({
        CountrySourceId: ToCountrySourceId,
        CountryId: TocountryID,
        CountryName: ToCountryName,
        CountryCode: ToCountryCode
      })),
      AddressLine1: null,
      AddressLine2: null,
      AddressLine3: null,
      AddressLine4: null,
      AddressLine5: null,
      FromDate: moment(this.travelDetailsForm.get("tripStartDate")?.value).format('YYYY-MM-DD'),
      ToDate: moment(this.travelDetailsForm.get("tripEndDate")?.value).format('YYYY-MM-DD'),
      NoofDays: parseInt(this.travelDetailsForm.get("travelingDays")?.value || '', 10),
      NoofTravellers: parseInt(this.travelDetailsForm.get("numberOfTravelers")?.value || '', 10),
      TravellersInformation: null,
      KRAPinTypeID:null,
      KRAPinNumber:null,
      Occupation:null,
      Postaladdress:null,
      DeclarationInfo:null,
      ConsentInfo:null,
      BeneficiaryName:null,
      BeneficiaryPhoneNumber:null
    }
    let stringParams=JSON.stringify(params);
    if (!this.selectedTemplateFile) {
      console.error('No file selected');
      return;
    }
    const formData = new FormData();
    formData.append('file', this.selectedTemplateFile, this.selectedTemplateFile.name);
    formData.append('sObject',stringParams);
    this.loader.show();
    this.restService.postData(formData, 'api/Quotation/UserProposalBulk').subscribe(
      {
        next: (data: any) => {
          try {

            if (data.rcode == 200) {
              this.GetUserProposalBulk();
              // this.router.navigate(['policy/underwriting', this.quotationId, this.quotesId]);
            }
            else if (data.rcode == 504) {
              this.errorHandler.hasOverlappingPassportDatesError(data);
            } 
             else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      });
  }

  DeclarationUpdate() {
    const selectedDeclarations = this.declarationForm.get('declarationInfo')?.value
    .map((checked, index) => checked ? { DeclarationId: this.declarationList[index].masterDataID } : null)
    .filter(value => value !== null);

    const selectedConsents = this.declarationForm.get('consentInfo')?.value
    .map((checked, index) => checked ? { ConsentId: this.consentList[index].masterDataID } : null)
    .filter(value => value !== null);

    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.selectedProduct.QuotesID,
      DeclarationInfo:selectedDeclarations,
      ConsentInfo:selectedConsents,
    }
    
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/DeclarationUpdate').subscribe(
      {
        next: (data: any) => {
          try {

            if (data.rcode == 200) {
              this.router.navigate(['policy/underwriting', this.quotationId, this.quotesId]);
            }
            else if (data.rcode == 504) {
              this.errorHandler.hasOverlappingPassportDatesError(data);
            } 
             else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      });
  }

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedTemplateFile = input.files[0];
      this.uploadTemplateForm.get('template')?.patchValue(this.selectedTemplateFile.name);
      this.GetQuotesBulk();
    } else {
      this.uploadTemplateForm.get('template')?.patchValue('');
      this.selectedTemplateFile=null;
    }
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; 
      fileInput.click();   
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    const uploadBox = event.target as HTMLElement;
    uploadBox.classList.add('drag-over');
  }

  onDragLeave(event: DragEvent): void {
    const uploadBox = event.target as HTMLElement;
    uploadBox.classList.remove('drag-over');
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    const uploadBox = event.target as HTMLElement;
    uploadBox.classList.remove('drag-over');
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.selectedTemplateFile = event.dataTransfer.files[0];
      this.uploadTemplateForm.get('template')?.patchValue(this.selectedTemplateFile?.name);
      this.GetQuotesBulk();
    } else {
      this.uploadTemplateForm.get('template')?.patchValue('');
      this.selectedTemplateFile=null;
    }
  }
  quotationStatusUpdate() {
    this.loader.show();
    let params = {
      QuotationID: this.quotationId,
      PaymentMethodID: '5d3154a9-5d2e-4c84-915e-b62b5ea2670a'
    }
    this.contentLoaderService.submitData('api/Quotation/QuotationStatusUpdateModify', params, this.messages).subscribe(
      {
        next: (data: any) => {
          try {
            if (typeof data === 'string') {
              this.currentMessage = data;
            }
            else if (data.rcode == 200) {
               this.loader.hide();
              this.policyService.setPolicyPaymentDetailes(data.rObj.policyNo, data.rObj.ReferenceNumber, false, '');
              this.router.navigate(['policy/my-policy']);
            }
            else if (data.rcode == 201) {
              this.loader.hide();
              this.policyService.setPolicyPaymentDetailes(data.rObj.policyNo, data.rObj.ReferenceNumber, true, data.rObj.ResponseMessage);
              this.router.navigate(['policy/my-policy']);
            }
            else if (data.rcode != 200 && data.rcode != 201) {
              this.loader.hide();
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.loader.hide();
            this.errorHandler.internalError();
          }
        },
        error: (error) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      }
    );
  
  }
}
